import { ReportResponse } from './Api/Report.response';

export class ReportEntity extends ReportResponse {
	public static tryCast(o: any): ReportEntity {
		const ret = new ReportEntity();
		return Object.assign(ret, o);
	}
}
